module.exports = __webpack_public_path__ + "static/img/car_new_mg_extendergc.b56ae5d5.png";